import N from "../../../shared-lib/logger.js";
import { SUBSCRIPTION_ID_DATA_ATTRIBUTE as f } from "../../common/constants.js";
import r, { OPTIONS as w } from "../../managers/braze-instance.js";
import { setupBannerUI as U } from "../../ui/js/banner-css.js";
import { addPassiveEventListener as J } from "../../util/dom-utils.js";
import { bannerToHtml as S } from "../display/banner-to-html.js";
import { destroyBannerHtml as A } from "../display/destroy-banner-html.js";
import { detectBannerImpressions as E } from "../display/detect-banner-impressions.js";
import { subscribeToBannersUpdates } from "../subscribe-to-banners-updates.js";
export function insertBanner(o, e) {
  if (!r.rr()) return;
  if (!o) return void N.error("Not inserting banner: banner was not provided.");
  if (!e)
    return void N.error("Not inserting banner: parentNode was not provided.");
  if (!r.ee(w.re))
    return void N.error(
      "Banners are disabled. Use the 'allowUserSuppliedJavascript' option for braze.initialize to enable these messages.",
    );
  U();
  const n = S(o, r.ee(w.er)),
    s = subscribeToBannersUpdates((s) => {
      const i = s[o.placementId];
      i ? e.replaceChildren(S(i, r.ee(w.er))) : A(n);
    });
  s && n.setAttribute(f, s), e.replaceChildren(n), J(window, "scroll", E), E();
}
